import {
	API_GET_ALL_NURSE,
	API_GET_ALL_NURSE_SUCCESS,
	API_GET_ALL_NURSE_FAIL,
	API_GET_ALL_NETWORKS,
	API_GET_ALL_NETWORKS_FAIL,
	API_GET_ALL_NETWORKS_SUCCESS,
} from "../actions/nurse";
import { createReducer } from "@reduxjs/toolkit";
import { ErrorAction, errorHandler } from "utils/error";

const initialState = {
	loading: false,
	list: [],
	networks: null,
};

const nurses = createReducer(initialState, {
	/** GET ALL **/
	[API_GET_ALL_NURSE]: (state, action) => {
		state.loading = true;
	},
	[API_GET_ALL_NURSE_FAIL]: (state, action) => {
		errorHandler("Infirmières MyRdv", ErrorAction.READ, action.error);
		state.loading = false;
	},
	[API_GET_ALL_NURSE_SUCCESS]: (state, action) => {
		state.loading = false;
		state.list = action.payload.data;
	},
	[API_GET_ALL_NETWORKS]: (state, action) => {
		state.loading = true;
	},
	[API_GET_ALL_NETWORKS_FAIL]: (state, action) => {
		errorHandler("Réseaux MyRdv", ErrorAction.READ, action.error);
		state.loading = false;
	},
	[API_GET_ALL_NETWORKS_SUCCESS]: (state, action) => {
		state.loading = false;
		state.networks = action.payload.data;
	},
});

export default nurses;
